import type { FC } from "react";
import Mascot from "../../assets/Mascot";
import TierBadge from "../../assets/TierBadge";
import { LOCKED_TIER } from "../../palette";
import type { Tier } from "../../types";

type Props = {
  tier: Tier;
  locked: boolean;
};

const TierEmblem: FC<Props> = ({ tier, locked }) => {
  const metal = locked ? LOCKED_TIER : tier;

  return (
    <span data-slot="tier-emblem" className="relative h-12 w-11 shrink-0">
      <span className="absolute -top-3.5 -left-4 size-19 rounded-full bg-[radial-gradient(circle,rgb(255_255_255/0.16)_0%,rgb(255_255_255/0.05)_42%,transparent_66%)]" />
      <TierBadge
        light={metal.badgeLight ?? LOCKED_TIER.badgeLight}
        dark={metal.badgeDark ?? LOCKED_TIER.badgeDark}
        locked={locked}
        className="relative w-11 drop-shadow-lg"
      />
      {!locked && (
        <Mascot
          tierName={tier.name}
          className="absolute top-2 left-1.5 size-8"
        />
      )}
    </span>
  );
};

export default TierEmblem;
